// FTEDN Creator — Idea Submission Form (wired to API)
import { useState } from 'react';
import { useVotingStore } from '../../stores/voting.store';
import { useToast } from '../../components/ui/Toast';
import { validateIdea, CATEGORY_LIST, CATEGORY_ICONS } from './voting.helpers';
import './IdeaForm.css';

interface IdeaFormProps {
  onClose: () => void;
}

export function IdeaForm({ onClose }: IdeaFormProps) {
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [category, setCategory] = useState('product');
  const [submitting, setSubmitting] = useState(false);
  const { submitIdea } = useVotingStore();
  const { addToast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validation = validateIdea({ title, description: desc, category });
    if (!validation.valid) {
      addToast({ type: 'warning', title: 'Missing info', message: validation.error });
      return;
    }

    setSubmitting(true);
    const ok = await submitIdea({ title, description: desc, category });
    setSubmitting(false);

    if (ok) {
      addToast({ type: 'xp', title: '+50 XP', message: 'Idea submitted! The team will review it.' });
      onClose();
    } else {
      addToast({ type: 'error', title: 'Failed', message: 'Could not submit idea.' });
    }
  };

  return (
    <div className="idea-form-container">
      <h2>Submit Your Idea</h2>
      <p className="idea-form-desc">What should OOEDN build next? Tell us everything.</p>
      <form onSubmit={handleSubmit} className="idea-form" id="idea-form">
        <input className="neo-input" placeholder="Idea title" value={title}
          onChange={(e) => setTitle(e.target.value)} required id="idea-title" />
        <textarea className="neo-input idea-textarea" placeholder="Describe your idea..."
          value={desc} onChange={(e) => setDesc(e.target.value)} required id="idea-desc" />
        <div className="idea-categories">
          {CATEGORY_LIST.map((c) => (
            <button key={c} type="button"
              className={`category-chip ${category === c ? 'active' : ''}`}
              onClick={() => setCategory(c)}>
              {CATEGORY_ICONS[c] || '📋'} {c}
            </button>
          ))}
        </div>
        <button type="submit" className="neo-btn neo-btn--primary" id="idea-submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit Idea'}
        </button>
      </form>
    </div>
  );
}
